(() => {
  const config = window.oroProtectionConfig;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  let busy = false;
  let lastCart;
  async function request(path, data) {
    const response = await fetch(root + path, data === undefined ? {headers: {Accept: 'application/json'}} : {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(data)});
    if (!response.ok) throw new Error(config.error);
    return response.json();
  }
  const protectionLines = cart => cart.items.filter(item => item.variant_id === config.id);
  window.oroNormalizeCart = async cart => {
    const lines = protectionLines(cart);
    const hasProducts = cart.items.some(item => item.variant_id !== config.id);
    if (!lines.length) return cart;
    if (!hasProducts || lines.length > 1 || lines[0].quantity !== 1) {
      const updates = {};
      lines.forEach((line, index) => { updates[line.key] = hasProducts && index === 0 ? 1 : 0; });
      return request('cart/update.js', {updates});
    }
    return cart;
  };
  window.oroProtectionHTML = (cart, instance = 'page') => {
    lastCart = cart;
    const template = document.getElementById('oro-protection-template');
    if (!template || !cart.items.some(item => item.variant_id !== config.id)) return '';
    const container = document.createElement('div');
    container.append(template.content.cloneNode(true));
    const selected = protectionLines(cart).length > 0 ? 'paid' : 'free';
    container.querySelectorAll('[data-oro-choice]').forEach(input => {
      input.name = 'oro-protection-' + instance;
      if (input.value === selected) input.setAttribute('checked', '');
      input.closest('label').classList.toggle('is-selected', input.value === selected);
    });
    return container.innerHTML;
  };
  function mount(cart) {
    document.querySelectorAll('[data-oro-protection]').forEach((target, index) => {
      target.innerHTML = window.oroProtectionHTML(cart, 'page-' + index);
    });
  }
  async function refreshPage(cart) {
    const section = document.querySelector('[data-oro-section]');
    if (section) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', section.dataset.oroSection);
      const response = await fetch(url);
      if (!response.ok) throw new Error(config.error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = doc.querySelector('[data-oro-section]');
      if (!replacement) throw new Error(config.error);
      section.replaceWith(replacement);
    }
    mount(cart);
    if (window.ykRefreshCart) await window.ykRefreshCart();
    document.querySelectorAll('.oro-fee, .yk-cp-row--tot, .yk-subtotal').forEach(node => {
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) node.animate([{backgroundColor:'#dfd0bd'}, {backgroundColor:'transparent'}], {duration:650});
    });
  }
  function lock(on) {
    busy = on;
    document.documentElement.classList.toggle('oro-busy', on);
    document.querySelectorAll('[data-oro-choice]').forEach(input => {input.disabled = on;});
    document.querySelectorAll('.oro-protection').forEach(node => {node.setAttribute('aria-busy', String(on));});
  }
  function message(text, error = false) {
    document.querySelectorAll('.oro-message').forEach(node => {node.textContent = text; node.classList.toggle('is-error', error);});
  }
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-oro-choice]');
    if (!input || busy) return;
    lock(true);
    message(config.busy);
    try {
      let cart = await request('cart.js');
      const lines = protectionLines(cart);
      if (input.checked) {
        if (!cart.items.some(item => item.variant_id !== config.id)) throw new Error(config.error);
        if (!lines.length) await request('cart/add.js', {items:[{id:config.id, quantity:1, properties:{'Selección':'Protección opcional elegida por el cliente','Condiciones':'Orovera — versión 23-10-2026'}}]});
      } else if (lines.length) {
        const updates = {};
        lines.forEach(line => {updates[line.key] = 0;});
        await request('cart/update.js', {updates});
      }
      cart = await window.oroNormalizeCart(await request('cart.js'));
      await refreshPage(cart);
      message(config.updated);
    } catch (error) {
      try {await refreshPage(await request('cart.js'));} catch (_) {if(lastCart) mount(lastCart);}
      message(config.error, true);
    } finally {lock(false);}
  });
  document.addEventListener('click', event => {
    if (busy && event.target.closest('.yk-checkout, .yk-cp-checkout, .yk-cp-qty, .yk-cp-del, .yk-cl-remove, .yk-qminus, .yk-qplus, .yk-us-add')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if(busy && event.target.matches('.yk-cp-form')) {event.preventDefault();event.stopImmediatePropagation();}
  }, true);
  document.addEventListener('oro:cart-updated', async event => {
    if(!document.querySelector('[data-oro-section]') || busy) return;
    lock(true);
    try {await refreshPage(event.detail);} catch (_) {message(config.error, true);} finally {lock(false);}
  });
  request('cart.js').then(async original => {
    const cart = await window.oroNormalizeCart(original);
    if(cart.item_count !== original.item_count) await refreshPage(cart);
    else {mount(cart);if(window.ykRefreshCart)window.ykRefreshCart();}
  }).catch(() => {});
})();
